<template>
	<div v-if="value" class="badge">{{ value }}</div>
</template>

<script>
export default {
	name: 'badge',
	props: {
		value: [String, Number]
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
.badge {
	@include badge(1.5rem);
}
</style>
